(() => {
  const root = document.querySelector(".greekway-landing") || document;
  const header = root.querySelector("[data-header]");
  const menuToggle = root.querySelector("[data-menu-toggle]");
  const mobileMenu = root.querySelector("[data-mobile-menu]");
  const tripForm = root.querySelector("[data-trip-form]");
  const revealItems = root.querySelectorAll(".reveal");
  const writeItems = root.querySelectorAll(
    ".hero h1, .hero-sub, .hero-body, .section-heading h2, .section-heading p, .section-copy h2, .section-copy p, .visual-copy h2, .visual-copy p, .contact h2, .contact p, .shopify-basic h1, .shopify-basic h2, .shopify-basic p"
  );

  const syncHeader = () => {
    if (!header) return;
    header.classList.toggle("is-scrolled", window.scrollY > 16);
  };

  const closeMenu = () => {
    if (!menuToggle || !mobileMenu) return;
    document.body.classList.remove("menu-open");
    mobileMenu.hidden = true;
    menuToggle.setAttribute("aria-expanded", "false");
  };

  window.addEventListener("scroll", syncHeader, { passive: true });
  syncHeader();

  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener("click", () => {
      const isOpen = menuToggle.getAttribute("aria-expanded") === "true";
      document.body.classList.toggle("menu-open", !isOpen);
      mobileMenu.hidden = isOpen;
      menuToggle.setAttribute("aria-expanded", String(!isOpen));
    });

    mobileMenu.addEventListener("click", (event) => {
      if (event.target.closest("a")) closeMenu();
    });
  }

  if (tripForm) {
    tripForm.addEventListener("submit", (event) => {
      event.preventDefault();

      const data = new FormData(tripForm);
      const name = data.get("name") || "";
      const date = data.get("date") || "";
      const departure = data.get("departure") || "";
      const service = "Full-stay GreekWay service";
      const guests = data.get("guests") || "";
      const message = data.get("message") || "";

      const text = [
        "Hello GreekWay,",
        `My name is ${name}.`,
        `I arrive in Rhodes on ${date}.`,
        `I leave Rhodes on ${departure}.`,
        `I am interested in the ${service}.`,
        guests ? `Guests: ${guests}.` : "",
        message ? `Message: ${message}` : "",
      ]
        .filter(Boolean)
        .join("\n");

      window.open(`https://wa.me/306971915891?text=${encodeURIComponent(text)}`, "_blank", "noopener,noreferrer");
    });
  }

  if ("IntersectionObserver" in window) {
    document.body.classList.add("animations-ready");

    const revealObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          entry.target.classList.toggle("visible", entry.isIntersecting);
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -8% 0px" }
    );

    revealItems.forEach((item) => revealObserver.observe(item));
  } else {
    revealItems.forEach((item) => item.classList.add("visible"));
  }

  writeItems.forEach((item, index) => {
    item.classList.add("write-text");
    item.style.transitionDelay = `${Math.min(index % 3, 2) * 45}ms`;
  });

  if ("IntersectionObserver" in window) {
    const writeObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          entry.target.classList.toggle("is-written", entry.isIntersecting);
        });
      },
      { threshold: 0.2, rootMargin: "0px 0px -8% 0px" }
    );

    writeItems.forEach((item) => writeObserver.observe(item));
  } else {
    writeItems.forEach((item) => item.classList.add("is-written"));
  }

  if (window.lucide) {
    window.lucide.createIcons();
  }
})();